import React from "react";
import { SimpleShowLayout, TextField, NumberInput } from "react-admin";

const FormTab = (props) => {
  return (
    <SimpleShowLayout {...props}>
      <TextField source="soccer.id" />
      <NumberInput source="soccer.playerGameCount" />
      <NumberInput source="soccer.totalGoals" />
      <NumberInput source="soccer.assists" />
      <NumberInput source="soccer.shutouts" />
    </SimpleShowLayout>
  );
};

export default FormTab;
